import { Injectable, signal } from '@angular/core';
import { Clinic } from '../../models';

@Injectable({ providedIn: 'root' })
export class ClinicService {
  private readonly _clinic = signal<Clinic | null>(null);

  readonly clinic = this._clinic.asReadonly();

  set(clinic: Clinic): void {
    this._clinic.set(clinic);
  }

  clear(): void {
    this._clinic.set(null);
  }
}
